import axios from "axios";

// Use a RELATIVE base URL so every API call is same-origin as the page
// (apex or www, preview or prod). This keeps the auth cookie first-party and
// avoids it being dropped as a cross-site cookie on the custom domain.
export const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

const viewAsParam = new URLSearchParams(window.location.search).get("viewAs");
if (viewAsParam) sessionStorage.setItem("viewAs", viewAsParam);
export const getViewAs = () => sessionStorage.getItem("viewAs");
export const exitViewAs = () => sessionStorage.removeItem("viewAs");
api.interceptors.request.use((cfg) => {
  const v = getViewAs();
  if (v) cfg.headers["X-View-As"] = v;
  return cfg;
});
let lastToast = 0;
api.interceptors.response.use(undefined, (err) => {
  if (getViewAs() && err?.response?.status === 403 && Date.now() - lastToast > 4000) {
    lastToast = Date.now();
    import("sonner").then(({ toast }) => toast("Mode aperçu : lecture seule, rien n'est enregistré"));
  }
  return Promise.reject(err);
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessaie.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
